import React from 'react';
import Lottie from 'react-lottie';
import './Login_Succes_Lottie.css';
import * as animationData from './Login_Succes_Lottie.json';

const Login_Succes_Lottie = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <>
            <section className='login-succes-lottie-section'>
                <div className='login-succes_Lottie'>
                    <Lottie className="me-auto"
                        options={defaultOptions}    
                    />
                </div>
            </section>
        </>
    )
}

export default Login_Succes_Lottie
